import React from 'react';
import PropTypes from 'prop-types';

import Article from '../../components/Article';

const Articles = ({ items, slide }) => {
  const hasArticles = !!items?.length;

  if (!hasArticles) {
    return null;
  }

  return (
    <div className='articles'>
      {items.map((item, index, articles) => {
        const nextArticle = articles[index + 1] || {
          title: 'MI by the numbers',
        };
        return (
          <Article
            {...item}
            nextArticle={nextArticle}
            slide={slide}
            index={index}
            key={`article-${index}`}
          />
        );
      })}
    </div>
  );
};

Articles.propTypes = {
  items: PropTypes.array,
  slide: PropTypes.string,
};

export default Articles;
